export default "__VITE_ASSET__COY$W$aU__"